var _defs, _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g3, _g4, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBillingAndFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189.909,
    height: 224.74,
    viewBox: "0 0 189.909 224.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2041",
    "data-name": "Rectangle 2041",
    width: 185.835,
    height: 217.282,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2038",
    "data-name": "Rectangle 2038",
    width: 68.3,
    height: 3.306,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22223",
    "data-name": "Group 22223",
    transform: "translate(15704.222 -9269.105)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22210",
    "data-name": "Group 22210",
    transform: "translate(-15661.178 9478.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11445",
    "data-name": "Path 11445",
    d: "M146.865,352.075c0,4.12-32.877,7.459-73.432,7.459S0,356.194,0,352.075s32.877-7.459,73.432-7.459,73.432,3.34,73.432,7.459",
    transform: "translate(0 -344.616)",
    fill: "#7586ec",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22221",
    "data-name": "Group 22221",
    transform: "translate(-15704.222 9269.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22220",
    "data-name": "Group 22220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22219",
    "data-name": "Group 22219",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22218",
    "data-name": "Group 22218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22217",
    "data-name": "Group 22217",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11446",
    "data-name": "Path 11446",
    d: "M156.2,1.43,155.12.354a.5.5,0,0,0-.705,0l-1.076,1.077a.5.5,0,0,1-.705,0L151.557.356a.5.5,0,0,0-.706,0l-1.076,1.077a.5.5,0,0,1-.705,0L147.994.357a.5.5,0,0,0-.705,0l-1.076,1.077a.5.5,0,0,1-.706,0L144.43.359a.5.5,0,0,0-.705,0l-1.076,1.077a.5.5,0,0,1-.705,0L140.867.36a.5.5,0,0,0-.706,0l-1.076,1.077a.5.5,0,0,1-.705,0L137.3.362a.5.5,0,0,0-.705,0l-1.076,1.077a.5.5,0,0,1-.706,0L133.74.363a.5.5,0,0,0-.705,0L131.958,1.44a.5.5,0,0,1-.705,0L130.176.365a.5.5,0,0,0-.706,0l-1.076,1.077a.5.5,0,0,1-.705,0L126.613.366a.5.5,0,0,0-.706,0l-1.076,1.077a.5.5,0,0,1-.705,0L123.049.368a.5.5,0,0,0-.706,0l-1.076,1.077a.5.5,0,0,1-.705,0L119.486.369a.5.5,0,0,0-.706,0L117.7,1.446a.5.5,0,0,1-.705,0L115.922.371a.5.5,0,0,0-.706,0l-1.076,1.077a.5.5,0,0,1-.705,0L112.359.372a.5.5,0,0,0-.706,0l-1.076,1.077a.5.5,0,0,1-.706,0L108.8.374a.5.5,0,0,0-.706,0l-1.076,1.077a.5.5,0,0,1-.705,0L105.232.375a.5.5,0,0,0-.706,0l-1.076,1.077a.5.5,0,0,1-.706,0L101.669.377a.5.5,0,0,0-.706,0L99.887,1.454a.5.5,0,0,1-.706,0L98.105.378a.5.5,0,0,0-.705,0L96.324,1.455a.5.5,0,0,1-.705,0L94.542.38a.5.5,0,0,0-.705,0L92.76,1.457a.5.5,0,0,1-.706,0L90.978.381a.5.5,0,0,0-.851.351L89.734,87.49l68.3.209.3-87.7L156.9,1.43a.5.5,0,0,1-.705,0",
    transform: "translate(-75.39)",
    fill: "#040227"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22213",
    "data-name": "Group 22213",
    transform: "translate(14.343 85.958)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_22212",
    "data-name": "Group 22212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22211",
    "data-name": "Group 22211",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2037",
    "data-name": "Rectangle 2037",
    width: 68.299,
    height: 3.277,
    transform: "translate(0.001 0.014)",
    fill: "#e3e3e3"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11447",
    "data-name": "Path 11447",
    d: "M170.262,474.516l39.708-.017a2.023,2.023,0,0,1,0,4.045l-39.708.017a2.023,2.023,0,1,1,0-4.045",
    transform: "translate(-141.347 -398.651)",
    fill: "#d2e4ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11448",
    "data-name": "Path 11448",
    d: "M301.655,422.815l26.837-.011a1.4,1.4,0,0,1,0,2.809l-26.837.011a1.4,1.4,0,0,1,0-2.809",
    transform: "translate(-252.256 -355.218)",
    fill: "#d2e4ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11449",
    "data-name": "Path 11449",
    d: "M301.635,374.417l26.837-.011a1.4,1.4,0,1,1,0,2.809l-26.837.011a1.4,1.4,0,1,1,0-2.809",
    transform: "translate(-252.239 -314.558)",
    fill: "#d2e4ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11450",
    "data-name": "Path 11450",
    d: "M301.616,331.027l26.837-.011a1.4,1.4,0,1,1,0,2.808l-26.837.011a1.4,1.4,0,1,1,0-2.809",
    transform: "translate(-252.223 -278.103)",
    fill: "#d2e4ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11451",
    "data-name": "Path 11451",
    d: "M200.129,264.752l31.6-.013a1.014,1.014,0,0,1,0,2.029l-31.6.013a1.014,1.014,0,0,1,0-2.029",
    transform: "translate(-167.287 -222.421)",
    fill: "#d2e4ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11452",
    "data-name": "Path 11452",
    d: "M157.923,239.423l45.089-.019a1.014,1.014,0,0,1,0,2.029l-45.089.019a1.014,1.014,0,0,1,0-2.029",
    transform: "translate(-131.827 -201.135)",
    fill: "#d2e4ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11453",
    "data-name": "Path 11453",
    d: "M125.842,422.932l7.36,0a1.4,1.4,0,0,1,0,2.809l-7.36,0a1.4,1.4,0,0,1,0-2.809",
    transform: "translate(-104.547 -355.324)",
    fill: "#d2e4ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11454",
    "data-name": "Path 11454",
    d: "M125.82,374.535l7.36,0a1.4,1.4,0,1,1,0,2.809l-7.36,0a1.4,1.4,0,1,1,0-2.809",
    transform: "translate(-104.528 -314.663)",
    fill: "#d2e4ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11455",
    "data-name": "Path 11455",
    d: "M125.8,331.144l7.36,0a1.4,1.4,0,0,1,0,2.809l-7.36,0a1.4,1.4,0,0,1,0-2.809",
    transform: "translate(-104.514 -278.208)",
    fill: "#d2e4ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11456",
    "data-name": "Path 11456",
    d: "M126.879,177.544l52.63-.022a2.56,2.56,0,1,1,0,5.12l-52.629.022a2.56,2.56,0,1,1,0-5.12",
    transform: "translate(-104.448 -149.145)",
    fill: "#d2e4ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11457",
    "data-name": "Path 11457",
    d: "M209.661,126.243l27.792-.012a1.585,1.585,0,0,1,0,3.17l-27.792.012a1.585,1.585,0,1,1,0-3.17",
    transform: "translate(-174.816 -106.053)",
    fill: "#d2e4ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11458",
    "data-name": "Path 11458",
    d: "M88.522,644.5l-79.7.034a8.766,8.766,0,0,1-8.77-8.763L0,517.349a8.766,8.766,0,0,1,8.763-8.77l79.7-.034a8.766,8.766,0,0,1,8.77,8.763l.05,118.424a8.766,8.766,0,0,1-8.763,8.77",
    transform: "translate(0 -427.255)",
    fill: "#9bc1f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22216",
    "data-name": "Group 22216",
    transform: "translate(2.213 83.448)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_22215",
    "data-name": "Group 22215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22224",
    "data-name": "Group 22224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11459",
    "data-name": "Path 11459",
    d: "M105.8,522.042a8.692,8.692,0,0,1,2.162,5.7l.05,118.424a8.766,8.766,0,0,1-8.763,8.77l-79.7.034a8.692,8.692,0,0,1-5.706-2.158,8.708,8.708,0,0,0,6.608,3.059l79.7-.034a8.767,8.767,0,0,0,8.763-8.77l-.05-118.424a8.708,8.708,0,0,0-3.064-6.605",
    transform: "translate(-13.843 -522.042)",
    fill: "#040227"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_22225",
    "data-name": "Group 22225",
    transform: "translate(-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11460",
    "data-name": "Path 11460",
    d: "M721.389,594.948l-.442.4a.542.542,0,0,1-.763-.019l-7.836-8.643a.536.536,0,0,1,.059-.758l.441-.4a.542.542,0,0,1,.764.019l7.836,8.643a.536.536,0,0,1-.059.758",
    transform: "translate(-598.37 -491.808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11461",
    "data-name": "Path 11461",
    d: "M757.271,600.622c-1.047-.855-9.147,2.712-9.044,3.953s-5.652,13.276-5.652,13.276l-9.944-7.956,0,0c-.088-.288-1.031-3.382-1.076-3.936-.048-.58-1.728-1.6-2.509-1.447s.668,1.132.763,1.312c.259.491-.742.675-.742.675s-2.873-1.582-2.934-2.513-.654-2.881-1.275-2.473c-.32.211-.317,1.594-.217,2.251-.185-.745-.446-1.587-.7-1.67-.465-.152-.7.441-.611.732s.835,3.456,1.063,3.812,4.863,4.1,5.532,4.913c0,0,12.862,14.754,13.779,15.14.8.339,3.669-4.746,6.376-8.121s10.471-15.281,7.2-17.951",
    transform: "translate(-607.687 -504.503)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11462",
    "data-name": "Path 11462",
    d: "M1092.624,1254.535s1.767,1.73,1.808,2.366.156,7.439-.565,8.074-2.841,1.085-2.16,1.8c.515.54,4.477.424,7.1.279.766-.042,1.728-6.179,2.031-7.081.441-1.31,1.513-4.26,1.112-5.173a7.652,7.652,0,0,0-2.446-2.213,12.054,12.054,0,0,1-2.71-2.9Z",
    transform: "translate(-917.087 -1049.929)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11463",
    "data-name": "Path 11463",
    d: "M948.638,1304.7s1.582,4.484,1.584,4.5c.117.711.581,2.465.581,3.111,0,2.426-10.9-2.059-8.46-3.134a2.592,2.592,0,0,0,.988-1.7,5.694,5.694,0,0,0-.918-2.868Z",
    transform: "translate(-791.409 -1096.063)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11464",
    "data-name": "Path 11464",
    d: "M861.163,782.905s-.795,8.038-.795,8.157c0,13-2.569,38.4-2.08,40.844,1.192,5.962,14.018,36.378,14.018,36.378l6.932-.831L870.2,831.037l3.324-14.657,4.7-28.973Z",
    transform: "translate(-721.04 -657.758)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11465",
    "data-name": "Path 11465",
    d: "M910.393,796.042l1.315,7.618,3.559,31.352,13.553,30.642s-1.906,4.459-4.719,5.085l-21.57-31.46-13.4-40.256.47-8.943Z",
    transform: "translate(-747.005 -663.786)",
    fill: "#262d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11466",
    "data-name": "Path 11466",
    d: "M859.3,552.6l9.612.985s.441-7.907.441-11.679c0-4.576-.389-10.47-.939-10.343a8.372,8.372,0,0,0-4.867,2.921C859.262,540.4,859.3,552.6,859.3,552.6",
    transform: "translate(-721.944 -446.595)",
    fill: "#6392dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11467",
    "data-name": "Path 11467",
    d: "M868.365,539.5c-.2,1.4-3.9,39.325-3.9,39.325,17.5,8.482,27.16,1.511,27.16,1.511s-.573-26.635.114-30.26c.454-2.4,1.02-18.336-.529-18.783a38.7,38.7,0,0,0-6.751-1.44c-2.121-.221-10.358-.349-11.832.148a18.855,18.855,0,0,0-4.265,9.5",
    transform: "translate(-726.282 -444.994)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11468",
    "data-name": "Path 11468",
    d: "M1095.688,1267.538s-4.074,11.509-5.668,12.065c-.423.147-2.455.521-2.839,1.423a3.912,3.912,0,0,0,0,1.178h8.491s1.074-5.071,1.5-7.3c0,0,2.248-5.444,2-5.938s-3.48-1.429-3.48-1.429",
    transform: "translate(-913.353 -1064.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11469",
    "data-name": "Path 11469",
    d: "M907.016,1336.993l-1.249-3.958s-2.622,1.113-3.933.927a39.614,39.614,0,0,1-3.871-.927c-5.233,1.728-9.521,2.567-8.741,3.958Z",
    transform: "translate(-747.003 -1119.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11470",
    "data-name": "Path 11470",
    d: "M844.707,712.415a2.266,2.266,0,0,1-.264-.2c.311-3.716.255-7.317-.907-8.534.028-.058.282-.6.547-1.162,1.347,1.045,1.987,3.823,1.736,8.331a7.678,7.678,0,0,1-.178.933c-.39.431-.745.709-.934.629",
    transform: "translate(-708.696 -590.225)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11471",
    "data-name": "Path 11471",
    d: "M1049.983,625.834a1.053,1.053,0,0,0,0-.244c-.258-2.627-2.431-24.684-2.8-25.622-.33-.847-10.079-14.836-10.079-14.836l-4.791,6.55,9.375,12.548c.21.8,3.593,15.687,3.593,15.687s.693,2.714,1,4.34c-.142.392-.281.762-.4,1.065a9.824,9.824,0,0,1-1.01,1.629,11.171,11.171,0,0,0-1.2,2.124c-.1.383-.278,1.179-.38,1.66s-.24,1.04-.263,1.3a2.522,2.522,0,0,1-.3.7.419.419,0,0,0,.494.606c.341-.114.606-.556.769-.832.461-.778.707-2.2.822-2.124s.519,2.486.583,2.758a29.8,29.8,0,0,0,.822,3.583c.274.512.636.426.732.106.083-.276-.3-4.192-.3-4.192s-.048-.5.17-.343.575,3.711.726,4.231.5.8.79.378c.357-.509-.257-4.279-.257-4.279s-.069-.474.133-.43.455,3.074.612,3.336a.4.4,0,0,0,.743-.081c.222-.514-.354-3.876-.354-3.876s.029-.268.154-.179.525,2.656.786,2.894a.276.276,0,0,0,.4.006c.478-.327-.255-2.769-.248-3.984s-.554-2.579-.387-4.025c.011-.091.04-.314.059-.454",
    transform: "translate(-867.304 -491.599)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11472",
    "data-name": "Path 11472",
    d: "M1022.376,556.087l-8.327,5.61s-4.693-7.008-7.213-9.5c-3.156-3.125,1.15-12.7,3.183-12.157,4.548,1.211,12.357,16.05,12.357,16.05",
    transform: "translate(-844.952 -453.694)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11473",
    "data-name": "Path 11473",
    d: "M947.236,477.018l1.245,8.237s-4.548,9.808-7.264,8.957c-2.278-.714-.877-9.392-.877-9.392s1.242-4.66.869-6.993,6.026-.81,6.026-.81",
    transform: "translate(-789.669 -400.356)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11474",
    "data-name": "Path 11474",
    d: "M947.183,477.827c-.372-2.332,6.026-.81,6.026-.81l.1.683a3.792,3.792,0,0,1-.694,1.148,8.41,8.41,0,0,1-5.594,2.54,12.76,12.76,0,0,0,.159-3.562",
    transform: "translate(-795.644 -400.356)",
    fill: "#faaa74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11475",
    "data-name": "Path 11475",
    d: "M934.861,393.156c.181-.066,1.449,9.382-.958,11.981s-7.1,3.45-8.781,1.4c-1.861-2.264-1.767-12.418,1.976-15.092s7.763,1.708,7.763,1.708",
    transform: "translate(-776.245 -328.148)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11476",
    "data-name": "Path 11476",
    d: "M935.549,364.069A10.391,10.391,0,0,1,941,367.191c1.314.156,3.1.884,4.943,3.947a7.677,7.677,0,0,1-2.046,9.987,5.974,5.974,0,0,0-2.6,4.412l-.417-1.223a6.857,6.857,0,0,1-.331-2.881,5.651,5.651,0,0,1,.427-1.732c.635-1.367-1.363-2.276-1.924-3.413-.431-.876-.452-2.88-1.132-4.328l-.812-1.105a5.15,5.15,0,0,0-3.7-1.05c-1.832.413-1.569-6.5,2.143-5.736",
    transform: "translate(-783.271 -305.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11477",
    "data-name": "Path 11477",
    d: "M975.33,440.469c-.019,1.153.5,2.1,1.166,2.108s1.216-.914,1.235-2.067-.5-2.1-1.166-2.108-1.216.914-1.235,2.066",
    transform: "translate(-819.425 -368.324)",
    fill: "#ffb27d"
  }))))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2042",
    "data-name": "Rectangle 2042",
    width: 74.39,
    height: 34.779,
    rx: 4,
    transform: "translate(11.668 92.921)",
    fill: "#d2e4ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2043",
    "data-name": "Rectangle 2043",
    width: 74.39,
    height: 15.458,
    rx: 4,
    transform: "translate(11.668 133.497)",
    fill: "#d2e4ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingAndFeedback);
export default __webpack_public_path__ + "static/media/billing-and-feedback.3ade442c528c3114c6bb54a005bfdf43.svg";
export { ForwardRef as ReactComponent };